
import React from 'react';
import CustomModal from '../../../../../components/Modal/CustomModal';
import CreateAcrApp from '../Functionality/CreateAcrApp';
import {CustomSelectAndChildren} from "../../../../../components/CustomSelectAndChildren";
import {Box, MenuItem} from "@mui/material";
import {CustomCheckbox} from "../../../../../components/CustomCheckbox";
import CustomDescriptionLabel from "../../../../../components/CustomDescriptionLabel";
import {CustomTextField} from "../../../../../components/CustomTextField";
import {MIN_MAX_ACR} from "../Model/Models";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CreateAcrModal = (props) => {
    const { onHide, controllerId, setModified } = props;
    const {
        t,
        acr,
        handleChange,
        emptyFields,
        controllers,
        getZones,
        sioOptions,
        readerEntryOptions,
        readerExitOptions,
        outputOptions,
        doorInputsOptions,
        inputsNormallyOpenOptions,
        isValidDoorHeldOpenDelay,
        handleSubmit,
        resetValues
    } = CreateAcrApp({ onHide, controllerId, setModified });

    return (
        <CustomModal
            title='create_acr'
            buttonConfirm='confirm'
            {...props}
            onHide={() => {
                onHide();
                resetValues();
            }}
            onConfirm={() => {
                handleSubmit();
            }}
        >
            <div className='row'>
                {controllerId == null &&
                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cam_controller"}
                                             name={"controllerId"}
                                             trans={"controller"}
                                             value={acr.controllerId}
                                             onChange={handleChange}
                                             required={true}
                                             emptyFields={emptyFields}
                                             showNoSelectionOption={false}
                    >
                        {Array.isArray(controllers) &&
                        controllers.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
                }
                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cam_sio"}
                                             name={"hidSioId"}
                                             trans={"SIO"}
                                             value={acr.hidSioId}
                                             onChange={handleChange}
                                             required={true}
                                             emptyFields={emptyFields}
                                             showNoSelectionOption={false}
                                             disabled={!acr.controllerId}
                    >
                        {Array.isArray(sioOptions) &&
                            sioOptions.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))
                        }
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren
                        id={"slt_crm_zone_id"}
                        name={"zoneId"}
                        trans={"zone"}
                        value={acr.zoneId}
                        onChange={handleChange}
                        required={true}
                        emptyFields={emptyFields}
                        showNoSelectionOption={false}
                        disabled={!acr.hidSioId}
                    >
                        {Array.isArray(getZones) &&
                        getZones.map((zone) => (
                            <MenuItem key={zone.id} value={zone.id}>
                                {zone.name.toUpperCase()}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomTextField
                        id="txt_cam_door_held_open_delay"
                        trans="door_held_open_delay"
                        type="number"
                        name="doorHeldOpenDelay"
                        value={acr.doorHeldOpenDelay}
                        onChange={handleChange}
                        required
                        emptyFields={emptyFields}
                        disabled={!acr.hidSioId}
                        length={2}
                        isValid={isValidDoorHeldOpenDelay}
                        isValidText={t("it_must_be_greater_than_x_or_equal_to", {min:MIN_MAX_ACR.DOOR_HELD_OPEN_DELAY.start, max:MIN_MAX_ACR.DOOR_HELD_OPEN_DELAY.end})}
                        helperText={t("it_must_be_greater_than_x_or_equal_to", {min:MIN_MAX_ACR.DOOR_HELD_OPEN_DELAY.start, max:MIN_MAX_ACR.DOOR_HELD_OPEN_DELAY.end})}

                    />
                </div>

                <div className={"col-12 center-text mt-3"}>
                    <CustomDescriptionLabel className='font-color-text-950' trans={t('entry')}/>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cam_entry_reader"}
                                             name={"entryReaderId"}
                                             trans={"reader"}
                                             value={acr.entryReaderId}
                                             onChange={handleChange}
                                             required={true}
                                             emptyFields={emptyFields}
                                             showNoSelectionOption={false}
                                             disabled={!acr.hidSioId}
                    >
                        {Array.isArray(readerEntryOptions) &&
                        readerEntryOptions.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))
                        }
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cam_entry_output"}
                                             name={"entryOutputId"}
                                             trans={"output"}
                                             value={acr.entryOutputId}
                                             onChange={handleChange}
                                             required={true}
                                             emptyFields={emptyFields}
                                             showNoSelectionOption={false}
                                             disabled={!acr.hidSioId}
                    >
                        {Array.isArray(outputOptions) &&
                        outputOptions.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))
                        }
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cam_door_input_id"}
                                             name={"doorInputId"}
                                             trans={"entry_input"}
                                             value={acr.doorInputId}
                                             onChange={handleChange}
                                             required={true}
                                             emptyFields={emptyFields}
                                             showNoSelectionOption={false}
                                             disabled={!acr.hidSioId}
                    >
                        {Array.isArray(doorInputsOptions) &&
                        doorInputsOptions.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))
                        }
                    </CustomSelectAndChildren>
                </div>


                <div className={"col-12 center-text mt-3"}>
                    <CustomDescriptionLabel className='font-color-text-950' trans={t('exit')}/>
                </div>

                <Box className='col-12'>
                    <CustomCheckbox id={"cb_cam_enable_exit_config"}
                                    trans={"enable_exit_configuration"}
                                    name={"enableExitConfig"}
                                    checked={acr.enableExitConfig}
                                    value={acr.enableExitConfig}
                                    onChange={(e) =>  handleChange(e)}
                                    disabled={!acr.hidSioId}
                    />
                </Box>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cam_exit_reader"}
                                             name={"exitReaderId"}
                                             trans={"reader"}
                                             value={acr.exitReaderId}
                                             onChange={handleChange}
                                             required={acr.enableExitConfig}
                                             emptyFields={emptyFields && acr.enableExitConfig}
                                             showNoSelectionOption={false}
                                             disabled={!acr.enableExitConfig}
                    >
                        {Array.isArray(readerExitOptions) &&
                        readerExitOptions.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))
                        }
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cam_exit_output"}
                                             name={"exitOutputId"}
                                             trans={"output"}
                                             value={acr.exitOutputId}
                                             onChange={handleChange}
                                             required={acr.enableExitConfig}
                                             emptyFields={emptyFields && acr.enableExitConfig}
                                             showNoSelectionOption={false}
                                             disabled={!acr.enableExitConfig}
                    >
                        {Array.isArray(outputOptions) &&
                        outputOptions.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))
                        }
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_cam_exit_input"}
                                             name={"exitInputId"}
                                             trans={"exit_input"}
                                             value={acr.exitInputId}
                                             onChange={handleChange}
                                             required={acr.enableExitConfig}
                                             emptyFields={emptyFields && acr.enableExitConfig}
                                             showNoSelectionOption={false}
                                             disabled={!acr.enableExitConfig}
                    >
                        {Array.isArray(inputsNormallyOpenOptions) &&
                            inputsNormallyOpenOptions.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))
                        }
                    </CustomSelectAndChildren>
                </div>
            </div>
        </CustomModal>

    );
};

export default CreateAcrModal;
